import { render, staticRenderFns } from "./ChatBot copy.vue?vue&type=template&id=14939767&scoped=true&"
import script from "./ChatBot copy.vue?vue&type=script&lang=js&"
export * from "./ChatBot copy.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot copy.vue?vue&type=style&index=0&id=14939767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14939767",
  null
  
)

export default component.exports